var _rect, _text, _text2, _text3, _text4, _text5, _g, _g2, _g3, _g4, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3AFig1SystemFiveStages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The system, five stages")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Human decisions above the line, automated checks below, measured cost underneath")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#7C3AED",
    fontWeight: 600
  }, "HUMAN DECISIONS (6)")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 425,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "AUTOMATED CHECKS")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 540,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "COST, SUBAGENT TOKENS")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 330,
    x2: 266,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464,
    y1: 330,
    x2: 484,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 682,
    y1: 330,
    x2: 702,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 330,
    x2: 920,
    y2: 330
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D4DDD6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 324 l10 6 l-10 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 324 l10 6 l-10 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 324 l10 6 l-10 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 324 l10 6 l-10 6 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 280,
    width: 198,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 322,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Read"), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 346,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "11 reader agents,"), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 362,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "9 sources, 287 candidates"), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 280,
    width: 198,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 322,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Decide"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 346,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "dedup, phasing,"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 362,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "8 shortlisted, 3 selected"), /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 280,
    width: 198,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 322,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Author"), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 346,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "3 acceptance contracts,"), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 362,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "rules as data, source quotes"), /*#__PURE__*/React.createElement("rect", {
    x: 702,
    y: 280,
    width: 198,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 322,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Integrate"), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 346,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "agents author data,"), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 362,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "the loop writes the files"), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 280,
    width: 198,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 322,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Audit"), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 346,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "cold contract audit,"), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 362,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "published claims vs grader")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 212,
    x2: 100,
    y2: 280,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 150,
    width: 118,
    height: 62,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 175,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "scope and"), /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 192,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "budget")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 365,
    y1: 212,
    x2: 365,
    y2: 280,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 150,
    width: 118,
    height: 62,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 175,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "which three"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 192,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "to build")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 583,
    y1: 212,
    x2: 583,
    y2: 280,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 150,
    width: 118,
    height: 62,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 175,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "sketch-review"), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 192,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "clearance")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 742,
    y1: 212,
    x2: 742,
    y2: 280,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 150,
    width: 118,
    height: 62,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 175,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "slate"), /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 192,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "clearance")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 985,
    y1: 212,
    x2: 985,
    y2: 280,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 150,
    width: 118,
    height: 62,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 985,
    y: 175,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "audit scope,"), /*#__PURE__*/React.createElement("text", {
    x: 985,
    y: 192,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "cut 3 to 2 on cost")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 299,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1161,
    y: 325,
    fontSize: 11.5,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontWeight: 600
  }, "merge"), /*#__PURE__*/React.createElement("text", {
    x: 1161,
    y: 341,
    fontSize: 11.5,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "to prod"), /*#__PURE__*/React.createElement("line", {
    x1: 1118,
    y1: 330,
    x2: 1128,
    y2: 330,
    stroke: "#7C3AED",
    strokeWidth: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 380,
    x2: 147,
    y2: 440,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 440,
    width: 198,
    height: 58,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 463,
    textAnchor: "middle"
  }, "over-capture protocol,"), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 481,
    textAnchor: "middle"
  }, "per-file parsed counts")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 583,
    y1: 380,
    x2: 583,
    y2: 440,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 440,
    width: 198,
    height: 58,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 463,
    textAnchor: "middle"
  }, "blind verifier re-derives"), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 481,
    textAnchor: "middle"
  }, "each contract, unaided")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 801,
    y1: 380,
    x2: 801,
    y2: 440,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702,
    y: 440,
    width: 198,
    height: 58,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 463,
    textAnchor: "middle"
  }, "full gate: 4,181 checks,"), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 481,
    textAnchor: "middle"
  }, "zero credentials")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1019,
    y1: 380,
    x2: 1019,
    y2: 440,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 440,
    width: 198,
    height: 58,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 463,
    textAnchor: "middle"
  }, "executed witnesses against"), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 481,
    textAnchor: "middle"
  }, "the live validator")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fill: "#4A5F56",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 570,
    textAnchor: "middle"
  }, "567,538"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 570,
    textAnchor: "middle"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 583,
    y: 570,
    textAnchor: "middle"
  }, "540,445"), /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 570,
    textAnchor: "middle"
  }, "184,090"), /*#__PURE__*/React.createElement("text", {
    x: 1019,
    y: 570,
    textAnchor: "middle"
  }, "202,613"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1152,
    y: 570,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "= 1,494,686")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3AFig1SystemFiveStages);
export default __webpack_public_path__ + "static/media/case3a-fig1-system-five-stages.9d7e0d38182ab6a2999de4fe9c8619b6.svg";
export { ForwardRef as ReactComponent };